export const LIKERT_COLORS = {
  positiva: '#61aa50',
  neutra: '#f5a119',
  negativa: '#e53935',
};

export const toNumber = (value) =>
  Number.isFinite(Number(value)) ? Number(value) : 0;

export const getLikertHeatMapRange = (value) => {
  if (value == null || value === '') return null;

  const number = Number(value);

  if (!Number.isFinite(number)) return null;
  if (number <= 40) return 'negativa';
  if (number < 70) return 'neutra';

  return 'positiva';
};

const normalizeCode = (value) =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

export const findLikertRange = (ranges, code) => {
  if (Array.isArray(ranges)) {
    return ranges.find((range) => normalizeCode(range.codigo) === code) || {};
  }

  if (ranges && typeof ranges === 'object') {
    const key = Object.keys(ranges).find(
      (rangeCode) => normalizeCode(rangeCode) === code
    );

    return (key && ranges[key]) || {};
  }

  return {};
};
